import { Box, Container } from '@mui/material'
import { useLocation } from 'react-router-dom';
import PageHeader from 'components/common/PageHeader/PageHeader';
import useGlobalStyles from 'styles/globalStyles';
import CategoryTree from 'components/Category/CategoryTree/CategoryTree';
import RawProductCarousel from 'components/RawProduct/RawProductCarousel/RawProductCarousel';
import { useGetRawProductCategoryCounts } from 'hooks/useRawProductCategoryReview';
import { RawProductCategoryCounts } from 'services/rawProductService';

// The same taxonomy walk as All Categories, carrying raw products instead of
// products.
export default function RawProductCategoriesPage() {
  const globalStyles = useGlobalStyles();
  const categoryName = (useLocation().state as { categoryName?: string } | null)?.categoryName;

  // Promoted out of filed, beside each category's name: which categories still
  // have raw products waiting is the reason this page is opened.
  const { data: counts } = useGetRawProductCategoryCounts();
  const subtitleFor = (categoryId: string) => {
    const count = (counts as RawProductCategoryCounts | undefined)?.[categoryId];
    return `(${count?.promoted ?? 0}/${count?.total ?? 0})`;
  };

  return (
    <Container
      maxWidth={'xl'}
      className={globalStyles.container}
    >
      <Box pt={2}>
        <PageHeader
          title={'Categories'}
          description={categoryName}
          buttons={[]}
        />
      </Box>

      <Box mt={3}>
        <CategoryTree
          basePath={'/raw-products/categories'}
          renderCarousel={() => <RawProductCarousel />}
          showAdd={false}
          subtitleFor={subtitleFor}
        />
      </Box>
    </Container>
  )
}
